module.exports = __webpack_public_path__ + "static/media/motorMapIcon2.a606f970.png";